import React, { PropsWithChildren, useContext } from 'react'
import * as S from './styles'
import { PanelContext } from './Panel';

export const PanelBody = ({children}: PropsWithChildren<any>) => {
    const { open } = useContext(PanelContext);

    if (!open) {
        return null;
    }

    return (
        <S.PanelBody>
            <div>{children}</div>
        </S.PanelBody>
    )
}